import { Button, Form, Modal } from "antd";
import { Flex } from "common/components/flex/flex";
import { CopyIcon } from "common/icons/CopyIcon";
import JobForm from "../../jobForm";
import { isPermissionPresent } from "utilities/generalUtility";
import K from "utilities/constants";
import { useSelector } from "react-redux";
import { selectUser } from "redux/slices/userSlice";

export const EditJobModal = ({
  clientId,
  job,
  open,
  loading,
  isDuplicate,
  onDuplicate,
  onCancel,
  onFinish,
}) => {
  const [form] = Form.useForm();
  const userRoles = useSelector(selectUser).roles;

  const isDuplicateBtnPresent = isPermissionPresent(K.Permissions.CreateJob, userRoles) && !isDuplicate;
  return (
    <Modal
      centered
      width={632}
      open={open}
      onCancel={onCancel}
      closeIcon={<i className="icon-closeable" />}
      className="s2-theme-style modal-overflow-auto"
      title={isDuplicate ? "Duplicate Job" : "Edit Job"}
      footer={
        <Flex
          justify={!isDuplicateBtnPresent ? "end" : "space-between"}
          style={{ marginLeft: 10 }}
        >
          {isDuplicateBtnPresent && (
            <Button icon={<CopyIcon />} onClick={onDuplicate}>
              Duplicate
            </Button>
          )}
          <Flex>
            <Button onClick={onCancel}>Cancel</Button>
            <Button type="primary" loading={loading} onClick={form.submit}>
              {isDuplicate ? "Duplicate" : "Submit"}
            </Button>
          </Flex>
        </Flex>
      }
    >
      {isDuplicate && (
        <p>
          This job is copied from {job.id}. Verify all fields are completed, and
          pre-populated data is accurate before creating the job.
        </p>
      )}
      <JobForm
        form={form}
        editData={job}
        clientId={clientId}
        onFinish={onFinish}
        isDuplicate={isDuplicate}
      />
    </Modal>
  );
};
